import axios from 'axios';
import { getAcessToken } from '@/modules/shared/storage';
export default (api) => {
  return axios.create({
    baseURL: api != null && api !== '' && api !== undefined ? api : process.env.VUE_APP_API_URL,
    timeout: 30000,
    headers: { Authorization: `bearer ${getAcessToken()}` },
  });
};
